export const calculateLivingExpenses = (financialBurden, bank, isConsumerCredit) => {
    const dependents = financialBurden?.numberOfDependents || 0;
    const lifeCost = isConsumerCredit
        ? bank.paramValues[2304]
        : bank.paramValues[2303];
    const childOutcomeBase = isConsumerCredit
        ? bank.paramValues[1363]
        : bank.paramValues[75];
    const childOutcome = childOutcomeBase * dependents;
    return { lifeCost, childOutcome, livingWage: childOutcome }; // livingWage в оригинале использовался как синоним childOutcome в одном месте
};
